'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';

import useShowOverlay from '../hooks/useShowOverlay';

import Modal from '../../_ui/Modal/Modal';
import Card from '../../_ui/_blocks/Card/Card';
import ButtonLink from '../../_ui/_blocks/Buttons/ButtonLink/ButtonLink';
import Link from '../../NextJs/Link/Link';

interface Props {
    linkTo: string;
}

const PpcAgeConfirmation = ({ linkTo }: Props) => {
    const { showOverlay } = useShowOverlay('ageCheck');

    const router = useRouter();

    if (!showOverlay) {
        return null;
    }

    const handleClose = () => router.push(linkTo);

    return (
        <Modal show onClose={handleClose} className="container-xsmall">
            <Card as="div" variant="bordered" className="space-y-100 text-center">
                <Image
                    src="/images/logo-dark.svg"
                    alt="The Independent Pharmacy"
                    className="mx-auto max-w-[10rem]"
                    width={160}
                    height={55}
                />
                <Modal.Title as="h2" typeset="subtitle" size="400" color="accent">
                    Are you 18 years or older?
                </Modal.Title>
                <Modal.Description as="p" size="090" color="quiet">
                    As a fully regulated UK online pharmacy, patients must be 18 years or older to buy medicines online.
                </Modal.Description>
                <ButtonLink href={linkTo} title="Yes I am 18+" className="w-full">
                    Yes I am 18+
                </ButtonLink>
                <Link href={linkTo} title="I'm just browsing" className="block type-link">
                    I'm just browsing
                </Link>
            </Card>
        </Modal>
    );
};

export default PpcAgeConfirmation;
